'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _managed_contract_wrapper = require('./managed_contract_wrapper');

var _managed_contract_wrapper2 = _interopRequireDefault(_managed_contract_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RolesPrivilagesStoreWrapper = function (_ManagedContractWrapp) {
  (0, _inherits3.default)(RolesPrivilagesStoreWrapper, _ManagedContractWrapp);

  function RolesPrivilagesStoreWrapper() {
    (0, _classCallCheck3.default)(this, RolesPrivilagesStoreWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (RolesPrivilagesStoreWrapper.__proto__ || Object.getPrototypeOf(RolesPrivilagesStoreWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(RolesPrivilagesStoreWrapper, [{
    key: 'getAllMultiplexerSelectors',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var selectors;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                selectors = {};
                _context.next = 3;
                return this.web3.eth.abi.encodeFunctionSignature('addToWhitelist(address,Consts.NodeType,uint256)');

              case 3:
                selectors.addToWhitelist = _context.sent;
                _context.next = 6;
                return this.web3.eth.abi.encodeFunctionSignature('removeFromWhitelist(address)');

              case 6:
                selectors.removeFromWhitelist = _context.sent;
                _context.next = 9;
                return this.web3.eth.abi.encodeFunctionSignature('setBaseUploadFee(uint256)');

              case 9:
                selectors.setBaseUploadFee = _context.sent;
                _context.next = 12;
                return this.web3.eth.abi.encodeFunctionSignature('setBaseReward(uint256)');

              case 12:
                selectors.setBaseReward = _context.sent;
                _context.next = 15;
                return this.web3.eth.abi.encodeFunctionSignature('retireApollo(address)');

              case 15:
                selectors.retireApollo = _context.sent;
                _context.next = 18;
                return this.web3.eth.abi.encodeFunctionSignature('setDeveloperFee(uint256)');

              case 18:
                selectors.setDeveloperFee = _context.sent;
                _context.next = 21;
                return this.web3.eth.abi.encodeFunctionSignature('setDeveloper(address)');

              case 21:
                selectors.setDeveloper = _context.sent;
                _context.next = 24;
                return this.web3.eth.abi.encodeFunctionSignature('setSupportFee(address,uint256)');

              case 24:
                selectors.setSupportFee = _context.sent;
                _context.next = 27;
                return this.web3.eth.abi.encodeFunctionSignature('addAdmin(address)');

              case 27:
                selectors.addAdmin = _context.sent;
                _context.next = 30;
                return this.web3.eth.abi.encodeFunctionSignature('removeAdmin(address)');

              case 30:
                selectors.removeAdmin = _context.sent;
                _context.next = 33;
                return this.web3.eth.abi.encodeFunctionSignature('addPool(address)');

              case 33:
                selectors.addPool = _context.sent;
                _context.next = 36;
                return this.web3.eth.abi.encodeFunctionSignature('removePool(address)');

              case 36:
                selectors.removePool = _context.sent;
                _context.next = 39;
                return this.web3.eth.abi.encodeFunctionSignature('setRole(string,bytes4[],bytes4[]))');

              case 39:
                selectors.setRole = _context.sent;
                _context.next = 42;
                return this.web3.eth.abi.encodeFunctionSignature('setRoles(address,bytes32[]))');

              case 42:
                selectors.setRoles = _context.sent;
                return _context.abrupt('return', selectors);

              case 44:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAllMultiplexerSelectors() {
        return _ref.apply(this, arguments);
      }

      return getAllMultiplexerSelectors;
    }()
  }, {
    key: 'hasPrivilage',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(user, selector) {
        var contract;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.contract();

              case 2:
                contract = _context2.sent;
                return _context2.abrupt('return', contract.methods.hasPrivilage(user, selector).call());

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function hasPrivilage(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return hasPrivilage;
    }()
  }, {
    key: 'hasRolePrivilage',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(roleHex, selector) {
        var contract;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.contract();

              case 2:
                contract = _context3.sent;
                return _context3.abrupt('return', contract.methods.hasRolePrivilage(roleHex, selector).call());

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function hasRolePrivilage(_x3, _x4) {
        return _ref3.apply(this, arguments);
      }

      return hasRolePrivilage;
    }()
  }, {
    key: 'getRoleNameByHex',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(roleHex) {
        var contract;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.contract();

              case 2:
                contract = _context4.sent;
                return _context4.abrupt('return', contract.methods.getRoleNameByHex(roleHex).call());

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getRoleNameByHex(_x5) {
        return _ref4.apply(this, arguments);
      }

      return getRoleNameByHex;
    }()
  }, {
    key: 'getRoleHexByName',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(roleName) {
        var contract;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.contract();

              case 2:
                contract = _context5.sent;
                return _context5.abrupt('return', contract.methods.getRoleHexByName(roleName).call());

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getRoleHexByName(_x6) {
        return _ref5.apply(this, arguments);
      }

      return getRoleHexByName;
    }()
  }, {
    key: 'getRoleHexes',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
        var contract;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.contract();

              case 2:
                contract = _context6.sent;
                return _context6.abrupt('return', contract.methods.getRoleHexes().call());

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getRoleHexes() {
        return _ref6.apply(this, arguments);
      }

      return getRoleHexes;
    }()
  }, {
    key: 'getRoles',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(account) {
        var contract;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.contract();

              case 2:
                contract = _context7.sent;
                return _context7.abrupt('return', contract.methods.getRoles(account).call());

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getRoles(_x7) {
        return _ref7.apply(this, arguments);
      }

      return getRoles;
    }()
  }, {
    key: 'getContractName',
    get: function get() {
      return 'rolesPrivilagesStore';
    }
  }]);
  return RolesPrivilagesStoreWrapper;
}(_managed_contract_wrapper2.default); /*
                                       Copyright: Ambrosus Inc.
                                       Email: tech@ambrosus.io
                                       
                                       This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0. If a copy of the MPL was not distributed with this file, You can obtain one at https://mozilla.org/MPL/2.0/.
                                       
                                       This Source Code Form is “Incompatible With Secondary Licenses”, as defined by the Mozilla Public License, v. 2.0.
                                       */

exports.default = RolesPrivilagesStoreWrapper;